import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    // Using a small timeout to ensure the new route has rendered
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);

    // Cleanup timeout if component unmounts
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default ScrollToTop;